import { useI18nGlobal } from '@/locales/provider'
import { useTitle } from '@vueuse/core'
import { watch } from 'vue'

export function useTitleI18n() {
  const { t, locale } = useI18nGlobal()

  const documentTitle = useTitle()
  watch(
    locale,
    () => {
      documentTitle.value = t('Rewards')
    },
    { immediate: true }
  )
}
